import { render, staticRenderFns } from "./EcovadisProcessor.vue?vue&type=template&id=7c6db2b2&scoped=true&"
import script from "./EcovadisProcessor.vue?vue&type=script&lang=js&"
export * from "./EcovadisProcessor.vue?vue&type=script&lang=js&"
import style0 from "./EcovadisProcessor.vue?vue&type=style&index=0&id=7c6db2b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6db2b2",
  null
  
)

export default component.exports